<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container mt-4">
    <h2 i18n>Notifications</h2>

    <div *ngIf="loading" class="text-center">
        <app-spinner></app-spinner>
    </div>

    <div *ngIf="!loading && notifications.length === 0" class="alert alert-info" i18n>
        No notifications found.
    </div>

    <div *ngIf="!loading && notifications.length > 0">
        <div class="list-group">
            <div *ngFor="let notification of notifications" class="list-group-item list-group-item-action d-flex flex-column align-items-start gap-2"
                 [class.list-group-item-light]="notification.is_read">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{ notification.title }}</h5>
                    <small>{{ notification.created.fromNow() }} <fa-icon [icon]="faMobileAlt" [ngClass]="{'text-success': notification.is_sent, 'text-danger': !notification.is_sent}"></fa-icon></small>
                </div>
                <p class="mb-1">{{ notification.message }}</p>
                <a [routerLink]="['/shipment', notification.shipment_id]" *ngIf="notification.shipment_id" i18n>View
                    Shipment</a>
                <button *ngIf="!notification.is_read" class="btn btn-sm btn-outline-primary"
                        (click)="markAsRead(notification)" i18n>Mark as read
                </button>
            </div>
        </div>

    </div>
</div>
